import { all, takeEvery, put, call } from 'redux-saga/effects'
import { currentAccount, logout } from 'services/user'
import { getMyCustomerContracts } from 'services/contract'
import { history } from 'index'
import actions from './actions'
import contractActions from '../contracts/actions'

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(currentAccount)
  console.log('LOAD_CURRENT_ACCOUNT response', response)
  if (response) {
    const {
      userID,
      email,
      name,
      surname,
      photoURL: avatar,
      roleName,
      roleName2,
      pageSize,
      userName,
      language,
      phone,
      mobile,
      passwordLocked,
      permissions: finalPermissionSet = [], // Backend sends as 'permissions', map to finalPermissionSet
    } = response
    let shortName
    try {
      shortName = `${name.substring(0, 1)}${surname.substring(0, 1)}`
      shortName = shortName.toUpperCase()
    } catch {
      //
    }

    let userRole = roleName
    if (roleName2 === 'admin') {
      userRole = roleName2
    }

    const statePayload = {
      id: userID,
      name: `${name} ${surname}`,
      email,
      avatar,
      role: userRole,
      role2: roleName2,
      authorized: true,
      pageSize,
      userName,
      language,
      passwordLocked,
      phone,
      mobile,
      shortName,
      permissions: finalPermissionSet, // Map finalPermissionSet to permissions array
      contractIds: response.contracts || [], // Store user's assigned contract IDs
    }
    console.log('SET_STATE payload:', statePayload)

    yield put({
      type: actions.SET_STATE,
      payload: statePayload,
    })

    localStorage.setItem('locale', language)
    localStorage.setItem('pageSize', pageSize)
    yield put({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'locale',
        value: language,
      },
    })
    if (passwordLocked === true) {
      history.push('/system/lockscreen')
    }

    // Auto-select first contract for customer users (uses /contract/my-contracts — no contract_view needed)
    const isCustomer = finalPermissionSet && finalPermissionSet.some(p => (typeof p === 'string' ? p : p?.slug) === 'customer_dashboard')
    const existingContract = localStorage.getItem('contract')
    if (isCustomer && !existingContract) {
      try {
        const contracts = yield call(getMyCustomerContracts)
        const validContracts = (contracts || []).filter(c => c && c.contractID)
        if (validContracts.length > 0) {
          yield put({
            type: contractActions.CHOOSE_CONTRACT,
            payload: validContracts[0],
          })
        }
      } catch (e) {
        console.log('Auto-select contract failed:', e)
      }
    }
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        authorized: false,
      },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(logout)
  localStorage.clear()
  try {
    // The selected project is kept per browser tab (redux/contracts/sagas.js).
    sessionStorage.removeItem('contract')
  } catch (e) {
    // sessionStorage unavailable - nothing stored there
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      id: '',
      name: '',
      role: '',
      role2: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
      pageSize: 15,
      language: 'en-US',
      permissions: [], // Clear permissions on logout
    },
  })
  // Clearing the auth state alone does not move the browser off the current
  // page (e.g. the No-Access 403 screen), so "Back to Login" appeared to do
  // nothing. Send the user to the login route explicitly.
  history.push('/system/login')
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    LOAD_CURRENT_ACCOUNT(),
  ])
}
